(function () {
  'use strict';

  const device = new MobileDetect(window.navigator.userAgent, 600);
  $_CONFIG.device = {
    mobile: !!device.mobile(),
    type: device.tablet() ? 'tablet' : device.phone() ? 'phone' : null,
  };
})();
